export const sxConfig = {
  containerBox: {
    px: 2,
    pt: 2,
    background: '#E9F5FE',
    minHeight: 'calc(100vh - 65px)',
  },

  wrapperBox: {
    background: '#fff',
    maxWidth: 800,
    height: '90vh',
    borderRadius: '12px',
    m: '0 auto',
    boxShadow: ' rgba(0, 0, 0, 0.1) 0px 4px 12px',
    overflowY: 'auto',
  },

  fieldContainer: {
    justifyContent: 'center',
    pt: 1,
  },

  fieldBox: {
    width: '250px',
  },

  fieldAddBtn: {
    alignItems: 'center',
    pt: 2.5,
  },

  editIcon: {
    margin: '3px',
    color: '#7d9eb0',
    p: '1px',
  },

  dialogContainer: {
    mt: 2,
  },

  dialogSaveBtn: {
    textAlign: 'center',
    mt: 2,
  },

  tableWrapper: {
    mt: 5,
    mb: 3,
    mx: 2,
  },

  tableContainer: {
    height: '670px',
  },

  table: {
    tableLayout: 'fixed',
    width: '100%',
  },

  tableBody: {
    '& .MuiTableCell-body': {
      padding: '10px 0px 10px 15px',
    },
  },

  badge: {
    cursor: 'pointer',
  },

  tableCellCenter: {
    textAlign: 'center',
  },

  tableCheckbox: { m: 0, p: 0 },
};
